import { NgModule } from "@angular/core";

import { CodeEditorModule } from "@acrodata/code-editor";

import { TextEditorsCoreModule } from "../text-editors-core.module";
import { HtmlEditorComponent } from "./components/html-editor.component";
import { HtmlEditorThemeService } from "./services/html-editor-theme.service";
import { HtmlEditorLanguageService } from "./services/html-editor-language.service";


@NgModule({
    declarations: [
        HtmlEditorComponent
    ],
    providers: [
        HtmlEditorLanguageService,
        HtmlEditorThemeService,
    ],
    exports: [
        HtmlEditorComponent,
    ],
    imports: [
        TextEditorsCoreModule,
        CodeEditorModule,
    ]
})
export class HtmlEditorModule {
}